import styled from 'styled-components'
import { themeGet } from 'styled-system'
import theme from 'styles/theme'
import { FormInputTextarea } from 'components/Typography'
import { getBGColor } from 'utils/themeUtils'

export const InputTextarea = styled(FormInputTextarea).attrs((props) => ({
  disabled: props.isDisabled,
}))`
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease-in-out;
  width: 100%;
  padding: ${theme.space[2]};
  background-color: ${getBGColor()};
  color: ${themeGet('colors.sagedark')};
  border-color: ${(props) =>
    !props.hasError
      ? props.theme.colors.sagelightToGreen
      : themeGet('colors.red')};

  &:focus {
    border-color: ${(props) =>
      !props.hasError ? theme.colors.sagemedium : themeGet('colors.red')};
  }
`

export const Wrapper = styled.div`
  margin: ${theme.space[6]} 0;

  ${theme.mediaQueries.small} {
    margin: ${theme.space[2]} 0;
  }
`
